import { render, staticRenderFns } from "./AdminTicketPage.vue?vue&type=template&id=b9be8d60&scoped=true&"
import script from "./AdminTicketPage.vue?vue&type=script&lang=js&"
export * from "./AdminTicketPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9be8d60",
  null
  
)

export default component.exports